import type Phaser from 'phaser';
import {nearestNpc,type NearbyNpc} from './npcInteraction';

export function installNpcTalk(scene:Phaser.Scene,npcs:readonly (NearbyNpc&{nameTh:string})[],open:(id:string)=>void):(id:string)=>void {
 const button=document.createElement('button');button.className='npc-talk hud-frame';button.hidden=true;button.type='button';
 button.innerHTML='<svg viewBox="0 0 24 24" aria-hidden="true"><path d="M5 4h14a2 2 0 0 1 2 2v10a2 2 0 0 1-2 2H9l-6 4V6a2 2 0 0 1 2-2Z"/><path d="M7 9h10M7 13h7"/></svg><span><strong>คุย</strong><small></small></span><kbd>E</kbd>';
 document.body.append(button);
 const eligible=()=>!document.body.classList.contains('rpg-modal')&&!document.querySelector('.party-panel:not([hidden]),.comms-panel:not([hidden])')&&Number(document.body.dataset.playerAltitude??0)<12&&Number(document.body.dataset.playerHp??1)>0;
 const current=()=>eligible()?nearestNpc(npcs,Number(document.body.dataset.worldX)):undefined;
 const request=(id:string)=>{const npc=npcs.find(n=>n.id===id);if(eligible()&&npc&&Math.abs(npc.x-Number(document.body.dataset.worldX))<=npc.range)open(id);};
 const update=()=>{
  const npc=current();button.hidden=!npc;document.body.dataset.nearNpc=npc?.id??'';
  if(npc){button.querySelector('small')!.textContent=npc.nameTh;button.setAttribute('aria-label','คุยกับ '+npc.nameTh);button.dataset.npc=npc.id;}
 };
 const key=(event:KeyboardEvent)=>{
  if(event.code!=='KeyE'||event.repeat||event.ctrlKey||event.altKey||event.metaKey)return;
  if(event.target instanceof Element&&event.target.closest('input,textarea,select,[contenteditable="true"]'))return;
  const npc=current();if(!npc)return;
  event.preventDefault();event.stopImmediatePropagation();request(npc.id);
 };
 button.addEventListener('click',()=>{const npc=current();if(npc)request(npc.id);});
 window.addEventListener('keydown',key,true);scene.events.on('update',update);
 scene.events.once('shutdown',()=>{window.removeEventListener('keydown',key,true);scene.events.off('update',update);button.remove();delete document.body.dataset.nearNpc;});
 return request;
}
